import { skillsList } from "constants/skills";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const addSkill = async (bodyData) => {
  try {
    const res = await api.add_skill(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getSkillList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_skill_list(pageNum, filters);
    dispatch({ type: skillsList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: skillsList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getSkillById = async (id) => {
  try {
    const res = await api.get_skill_by_id(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateSkillById = async (id, bodyData) => {
  try {
    const res = await api.update_skill_by_id(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};